/*
 * @Author: Terry
 * @Date: 2022-03-31 17:06:19
 * @LastEditors: Terry
 * @LastEditTime: 2022-03-31 18:02:06
 * @FilePath: /shenghuorongmei_vue/Users/www/code_obj/toutiao_01/src/api/share.js
 * @Description: 
 * 
 * Copyright (c) 2022 by ccde_terry@163.com, All Rights Reserved. 
 */
import {get,post} from '../utils/request'

export const getWxConfig = param => get('/addons/wechat/share/share',param)